import { render, staticRenderFns } from "./ServicePlaceServices.vue?vue&type=template&id=a5daa8b0&scoped=true&"
import script from "./ServicePlaceServices.vue?vue&type=script&lang=js&"
export * from "./ServicePlaceServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5daa8b0",
  null
  
)

export default component.exports